import { call, take }   from 'redux-saga/effects';
import axios            from 'axios';

//const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/testSandboxLrs.php';
//const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/testGovLrs.php';
const endpoint = `https://www.yisumatica.org.il/api/getUserPermissionsTest.php`;




function* doTest(): Generator<any,any,any> {
  while(true) {
    try {

        yield take('DO_TEST');

        const obj = {
          userEmail: '99999999',
          userId:    '99999999',
          schoolId:  '99999999'
       }

       console.log('obj : ',obj)

        const res = yield call( axios.post, endpoint, obj );

        console.log('res  :  ',res)


        
    }
    catch(err) {
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default doTest;
